export default "__VITE_ASSET__d77400e2__"